module.exports = __webpack_public_path__ + "img/jiejuefanganjingli.b89fe7bb.png";